import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from '@Organizations/OrganizationUnits/commands-core'
import { isRef, ref, Ref } from 'vue'

export function useApplyBrandingCommandV1(
	id?: string | Ref<string> | (() => string), 
	logoBlobId?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _logoBlobId = isRef<string>(logoBlobId) ? logoBlobId : ref<string>((typeof logoBlobId === 'function') ? logoBlobId() : logoBlobId)

	const result = {
		id: _id,
		logoBlobId: _logoBlobId,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof logoBlobId === 'function') { _logoBlobId.value = logoBlobId() }

			return new c.ApplyBrandingCommandV1(_id.value, _logoBlobId.value)
		})
	}

	return {
		...result,
		authorizedApplyBrandingCommandV1: result.authorized,
		applyBrandingCommandV1: result.command,
		completedApplyBrandingCommandV1: result.completed,
		errorApplyBrandingCommandV1: result.error,
		invokeApplyBrandingCommandV1: result.invoke,
		invokingApplyBrandingCommandV1: result.invoking,
		succeedApplyBrandingCommandV1: result.succeed,
		validationErrorsApplyBrandingCommandV1: result.validationErrors,
		onSucceedApplyBrandingCommandV1: result.onSucceed,
	}
}

export function useConfigureOauth2CommandV1(
	id?: string | Ref<string> | (() => string), 
	clientId?: string | Ref<string> | (() => string), 
	clientSecret?: string | Ref<string> | (() => string), 
	tokenEndpointUri?: string | Ref<string> | (() => string), 
	authorizationEndpointUri?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _clientId = isRef<string>(clientId) ? clientId : ref<string>((typeof clientId === 'function') ? clientId() : clientId)
	const _clientSecret = isRef<string>(clientSecret) ? clientSecret : ref<string>((typeof clientSecret === 'function') ? clientSecret() : clientSecret)
	const _tokenEndpointUri = isRef<string>(tokenEndpointUri) ? tokenEndpointUri : ref<string>((typeof tokenEndpointUri === 'function') ? tokenEndpointUri() : tokenEndpointUri)
	const _authorizationEndpointUri = isRef<string>(authorizationEndpointUri) ? authorizationEndpointUri : ref<string>((typeof authorizationEndpointUri === 'function') ? authorizationEndpointUri() : authorizationEndpointUri)

	const result = {
		id: _id,
		clientId: _clientId,
		clientSecret: _clientSecret,
		tokenEndpointUri: _tokenEndpointUri,
		authorizationEndpointUri: _authorizationEndpointUri,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof clientId === 'function') { _clientId.value = clientId() }
			if (typeof clientSecret === 'function') { _clientSecret.value = clientSecret() }
			if (typeof tokenEndpointUri === 'function') { _tokenEndpointUri.value = tokenEndpointUri() }
			if (typeof authorizationEndpointUri === 'function') { _authorizationEndpointUri.value = authorizationEndpointUri() }

			return new c.ConfigureOauth2CommandV1(_id.value, _clientId.value, _clientSecret.value, _tokenEndpointUri.value, _authorizationEndpointUri.value)
		})
	}

	return {
		...result,
		authorizedConfigureOauth2CommandV1: result.authorized,
		configureOauth2CommandV1: result.command,
		completedConfigureOauth2CommandV1: result.completed,
		errorConfigureOauth2CommandV1: result.error,
		invokeConfigureOauth2CommandV1: result.invoke,
		invokingConfigureOauth2CommandV1: result.invoking,
		succeedConfigureOauth2CommandV1: result.succeed,
		validationErrorsConfigureOauth2CommandV1: result.validationErrors,
		onSucceedConfigureOauth2CommandV1: result.onSucceed,
	}
}

export function useCreateOrganizationUnitCommandV1(
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)

	const result = {
		id: _id,
		name: _name,
		description: _description,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }

			return new c.CreateOrganizationUnitCommandV1(_id.value, _name.value, _description.value)
		})
	}

	return {
		...result,
		authorizedCreateOrganizationUnitCommandV1: result.authorized,
		createOrganizationUnitCommandV1: result.command,
		completedCreateOrganizationUnitCommandV1: result.completed,
		errorCreateOrganizationUnitCommandV1: result.error,
		invokeCreateOrganizationUnitCommandV1: result.invoke,
		invokingCreateOrganizationUnitCommandV1: result.invoking,
		succeedCreateOrganizationUnitCommandV1: result.succeed,
		validationErrorsCreateOrganizationUnitCommandV1: result.validationErrors,
		onSucceedCreateOrganizationUnitCommandV1: result.onSucceed,
	}
}

export function useResetBrandingCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.ResetBrandingCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedResetBrandingCommandV1: result.authorized,
		resetBrandingCommandV1: result.command,
		completedResetBrandingCommandV1: result.completed,
		errorResetBrandingCommandV1: result.error,
		invokeResetBrandingCommandV1: result.invoke,
		invokingResetBrandingCommandV1: result.invoking,
		succeedResetBrandingCommandV1: result.succeed,
		validationErrorsResetBrandingCommandV1: result.validationErrors,
		onSucceedResetBrandingCommandV1: result.onSucceed,
	}
}

export function useUpdateOrganizationUnitCommandV1(
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)

	const result = {
		id: _id,
		name: _name,
		description: _description,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }

			return new c.UpdateOrganizationUnitCommandV1(_id.value, _name.value, _description.value)
		})
	}

	return {
		...result,
		authorizedUpdateOrganizationUnitCommandV1: result.authorized,
		updateOrganizationUnitCommandV1: result.command,
		completedUpdateOrganizationUnitCommandV1: result.completed,
		errorUpdateOrganizationUnitCommandV1: result.error,
		invokeUpdateOrganizationUnitCommandV1: result.invoke,
		invokingUpdateOrganizationUnitCommandV1: result.invoking,
		succeedUpdateOrganizationUnitCommandV1: result.succeed,
		validationErrorsUpdateOrganizationUnitCommandV1: result.validationErrors,
		onSucceedUpdateOrganizationUnitCommandV1: result.onSucceed,
	}
}

